<template>
  <HPopup class="h-shop-popup"
          ref="popup"
          v-show="visible">
    <div class="h-shop-popup-body">
      <p class="popup-header">黑市</p>
      <!-- 金币 -->
      <div class="top-row h-outer-border around-4 bw2 bz0 h-bg brown-2">
        <div class="cargo-tabs">
          <button v-click-sound-button
                  class="tab h-btn ADOPB2ON"
                  :class="{ active: item.id === activeTab }"
                  v-for="item in classifiedCargo"
                  @click="activeTab=item.id">
            {{ item.name }}
          </button>
        </div>
        <div class="hero-gold">
          <img class="icon" :src="`${$rHost}/img/common/resource/GOLDICON.png`" alt="">
          <span class="gold-value h-title nowrap" :data-title="`当前拥有 ${gold } 金币`">{{ gold }}</span>
        </div>
      </div>

      <div class="cargo-list">
        <div class="cargo-item h-outer-border around-4 bw3 bz0 h-bg brown-2"
             :class="['quality-' + item.quality]"
             v-for="item in classifiedCargo[activeTab - 1].list">
          <div class="icon h-outer-border around-4 bw2 bz0">
            <div class="icon-wrapper h-effect"
                 :class="['quality-' + item.quality, (item.id > 1000 && item.id < 3000) ? 'equipment' : '']">
              <img class="artifact-icon" :src="cargoUrl(item.sourceName)" alt="">
            </div>
            <HArtifactInfoBox :artifact-info="item" :show-use-help="false"></HArtifactInfoBox>
          </div>
          <div class="cargo-info title">
            <p class="name" :class="[item.pictureUrl ? 'link' : '']" @click="viewPhoto(item.pictureUrl)">
              {{ item.nameCn }}
            </p>
            <p v-if="item.stock < 100" class="stock tight">
              仅剩 {{ item.stock }} 件
            </p>
            <div class="cost">
              <template v-if="item.discount < 1 && item.discount > 0">
                <span class="normal-price">{{ item.gold }}</span>
                <span class="discount-price">{{ item.sellingGold }}</span>
              </template>
              <template v-else>
                {{ item.sellingGold }}
              </template>
            </div>
          </div>
          <div class="buttons">
            <div class="buy-limit" v-if="item.buyLimit">
              {{ item.buyLimit ? `限购 ${item.buyLimit} 件` : '' }}
            </div>
            <div class="btn-buy"
                 :class="{disabled: item.sellingGold > gold}"
                 v-click-sound-button="item.sellingGold <= gold"
                 @click="handleBuy(item)">购买
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <button ref="button"
                v-click-sound-button
                class="h-button ok"
                @click="handleClose">
        </button>
      </div>
    </div>
  </HPopup>
</template>

<script>
  import HPopup from '@/components/h-popup/index.vue'
  import { mapGetters, mapActions } from 'vuex'
  import API from '@js/api'
  import AudioCtrl from '@js/audio-ctrl'
  import HArtifactInfoBox from '@/components/h-artifact-info-box'
  import AUDIO from '@/js/constants/AUDIO'

  export default {
    beforeDestroy () {
      AudioCtrl.stop(this.audioId)
    },

    data () {
      return {
        cargoList: [],
        activeTab: 1,
        buyLoading: false,
        audioId: null,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    watch: {
      visible (val) {
        if (val) {
          this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.LOOPMINE, loop: false })
          this.getCargoList()
        } else {
          AudioCtrl.stop(this.audioId)
        }
      }
    },

    computed: {
      ...mapGetters('hero', [
        'gold'
      ]),

      ...mapGetters('device', [
        'isMobile',
      ]),

      classifiedCargo () {
        return [
          {
            id: 1,
            name: '物品',
            list: this.cargoList.filter((d) => d.id < 400)
          },
          {
            id: 2,
            name: '资源',
            list: this.cargoList.filter((d) => d.id > 400 && d.id < 500)
          },
          {
            id: 3,
            name: '装备',
            list: this.cargoList.filter((d) => d.id > 1000 && d.id < 3000)
          },
        ]
      },
    },

    async mounted () {
      this.$refs.popup.$el.style.zIndex = this.zIndex
    },

    activated () {
      this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.LOOPMINE, loop: false })
      this.getCargoList()
    },

    deactivated () {
      AudioCtrl.stop(this.audioId)
    },

    methods: {
      ...mapActions('hero', [
        'getGold'
      ]),

      ...mapActions('gameSocket', [
        'appendSystemMessage'
      ]),

      async getCargoList () {
        try {
          this.cargoList = await API.shop.getCargoList()
        } catch (err) {
          console.error(err)
        }
      },

      cargoUrl (sourceName) {
        return `${this.$rHost}/img/artifact/${sourceName}`
      },

      handleClose () {
        this.$emit('close', false)
      },

      viewPhoto (url) {
        if (url) {
          window.open(url)
        }
      },

      async handleBuy (item) {
        try {
          if (this.buyLoading) {
            return
          }

          this.buyLoading = true

          if (item.sellingGold > this.gold) {
            return
          }

          const confirm = await this.$confirm(`即将购买【${item.nameCn}】，请确认。`)
          if (!confirm) {
            return
          }

          await API.shop.buy({
            artifactId: item.id,
            amount: 1,
            price: item.sellingGold,
          })
          this.$message(`【${item.nameCn}】已购买，可在背包查看物品。`)
          this.appendSystemMessage(`【${item.nameCn}】已购买，可在背包查看物品。`)
          this.getGold()
          this.cargoList = await API.shop.getCargoList()
        } catch (err) {
          this.$message(err)
        } finally {
          this.buyLoading = false
        }
      }

    },

    components: {
      HPopup,
      HArtifactInfoBox,
    }
  }
</script>

<style lang="stylus" scoped>
  .h-shop-popup-body
    width 728px

  .h-shop-header
    margin-bottom 30px
    text-align center
    letter-spacing 5px
    goldText()

  .top-row
    display flex
    padding 3px 5px

  .hero-gold
    flex-grow 1
    display flex
    align-items center
    justify-content flex-end
    .icon
      height 14px
      vertical-align middle
    .gold-value
      display inline-block
      padding-left 10px
      line-height 14px
      font-size 12px
      letter-spacing 1px
      whiteText1()
      cursor help

  .cargo-tabs
    display flex
    .h-btn
      goldText1()
      margin-right 5px
      width 57px
      height 30px
      font-size 12px
      letter-spacing 2px
      filter grayscale(0.75)
      &:hover
        filter grayscale(0.5)
      &.active
        filter grayscale(0)

  .cargo-list
    display flex
    min-height 280px
    flex-wrap wrap
    justify-content space-between
    align-content flex-start
    margin-top 5px

  .cargo-item
    position relative
    width 240px
    height 65px
    display flex
    align-items center
    margin-bottom 4px
    padding 5px
    user-select none
    &:hover
      z-index 2
      box-shadow 1px 1px 0 1px #000
    > div
      flex-shrink 0
    .icon
      width 55px
      height 55px
      display flex
      align-items center
      justify-content center
      padding 3px
      z-index 2
      &:hover .h-artifact-info-box
        display block
      .icon-wrapper
        position relative
      .artifact-icon
        max-width 100%
        max-height 100%
        vertical-align top
    .cargo-info
      display flex
      flex-direction column
      justify-content space-evenly
      padding 0 5px
      width 125px
      height 100%
      &:after
        width 130px
      .name
        line-height 16px
        font-size 12px
        letter-spacing 1px
        whiteText1()
        &.link:hover
          cursor pointer
          text-decoration underline
          color #2196f3
      .stock
        line-height 14px
        font-size 12px
        whiteText1()
        opacity 0.4

    .cost
      position relative
      display flex
      line-height 16px
      font-size 12px
      letter-spacing 1px
      goldText1()
      .normal-price
        margin-right 5px
        transform-origin left center
        text-decoration line-through
        color #888
        text-shadow 1px 1px 1px #000

    .buy-limit
      font-size 12px
      text-align center
      margin-bottom 5px
      transform-origin center center
      transform scale(0.8333, 0.8333)
      whiteText1()

    .buttons
      display flex
      flex-direction column
      align-items center
      justify-content center
      .btn-buy
        z-index 1
        padding 3px 10px
        border 1px solid #78624a
        border-radius 2px
        text-align center
        font-size 12px
        background-color #392519
        cursor pointer
        user-select none
        letter-spacing 1px
        goldText1()
        &:hover
          color darken($colorGold, 30%)
          cursor pointer
        &.disabled
          color rgba(255, 255, 255, .2)
          border-color rgba(255, 255, 255, .2)
          cursor not-allowed

  .footer
    margin-top 30px
    text-align center
    > button
      box-sizing content-box
      border 2px solid $colorGold

</style>
